import React, { useEffect, useState } from 'react';
import { CommonWrapper } from '../../CommonWrapper';
import { useLocale } from 'locale';
import { Button } from 'ds/components/button';
import { Nav } from '../../styled';
import { Slider } from 'ds/components/slider';
import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { TextField } from 'ds/components/input/TextField';
import { isNil } from 'lodash';
import { useScreenBreakpoint } from 'consts/breakpoints';


const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const Value = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;
interface IImportantArea {
  isActive: boolean;
  isSaved: boolean;
  title: string;
  text?: string;
  btnText?: string;
  setArea: any;
  data: number;
  onUpdate: (data: { [key: string]: any }) => void;
  selfClick?: () => void;
  fullActive?: boolean;
}

const MIN_VALUE = 150000;
const MAX_VALUE = 7000000;
const DEFAULT_VALUE = 3500000;

export function unformatCurrency(str: string): number {
  const cleaned = str.replace(/[^\d.-]/g, '');
  const normalised = cleaned.replace(',', '.');

  return Number(normalised);
}

export const BudgetArea: React.FC<IImportantArea> = ({ isActive, isSaved, title, text, btnText, data, onUpdate, setArea, selfClick, fullActive }) => {
  const { t, formatMoney, unformatMoney } = useLocale();
  const [ value, setValue ] = useState(DEFAULT_VALUE);
  const [ inputValue, setInputValue ] = useState<any>(formatMoney(DEFAULT_VALUE));
  const screen = useScreenBreakpoint();
  const isMobile = screen === 1;

  useEffect(() => {
    setValue(data || DEFAULT_VALUE);
    setInputValue(formatMoney(data || DEFAULT_VALUE));
  }, [ data ]);

  const handleSubmit = () => {
    setArea();
    onUpdate({ budget: value });
  };

  const onBlur = () => {
    switch (true) {
      case !isNil(inputValue) && Number(inputValue) > MAX_VALUE:
        setInputValue(formatMoney(MAX_VALUE));
        setValue(MAX_VALUE);
        break;
      case !isNil(inputValue) && Number(inputValue) < MIN_VALUE:
        setInputValue(formatMoney(MIN_VALUE));
        setValue(MIN_VALUE);
        break;
      default:
        setInputValue(formatMoney(inputValue));
        setValue(inputValue);
    }
  };

  const onFocus = () => {
    setInputValue(unformatMoney(inputValue));
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.currentTarget.value ? Number(e.currentTarget.value) : 0);
  };

  const handleSlider = (v: number) => {
    setInputValue(formatMoney(v));
    setValue(v);
  };

  return (
    <CommonWrapper {...{ isActive, isSaved, title, text, selfClick }}>
      <>
        <TextField
          label={null}
          value={inputValue}
          onBlur={onBlur}
          onChange={handleChangeInput}
          onFocus={onFocus}
          fullWidth
          type="tel"
          style={{ marginBottom: 16, textAlign: 'right' }}
        />
        <Slider
          min={MIN_VALUE}
          max={MAX_VALUE}
          value={value}
          step={10000}
          onChange={handleSlider}
          isLTR
        />
        <InfoWrapper>
          <Value>{t('investors.budget.max')}</Value>
          <Value>{formatMoney(value || DEFAULT_VALUE)}</Value>
        </InfoWrapper>
        {isActive ? (
          <Nav>
            <Button disabled={fullActive ? (!value || value === data) : !value} fullWidth={isMobile} size="extraLarge" onClick={handleSubmit}>{btnText || t('investors.wizard.submitButton')}</Button>
          </Nav>
        ) : null}
      </>
    </CommonWrapper>
  );
};
